fx.ns("filters", class SortPhotosChronological extends fx.Filter {

	constructor(data)
	{
		super(data);
		this.label = fx.text("Ordre Chronologique");
		this._photosused = true;
		//this._sortType = "ASC";
	}
	
	
	get photosused()
	{
		return this._photosused;
	}

	set photosused(val)
	{
		this._photosused = val;

		this.refresh();

		this.trigger("updated");
	}

	/*get sortType()
	{
		return this._sortType;
	}*/



	exec()
	{
		if (!this.rawData || !this.rawData.length) return [];
		
		let photos = this.rawData;
		
		// sort pictures chronologically
		photos = photos.sort( this._sortDateTaken );
		photos = photos.filter(this._filterPhotos, this );

		if (photos.length == 0)
			return [];

		let photo_groups = [];

		if (photos.length == 1)
		{
			photo_groups.push({'type':'label','text':this._getDate(photos[0].date_taken, true)})
			photo_groups.push(photos[0]);		
			return photo_groups;
		}

		//// -----------
		let photo_clusters = this.dbscan(photos);

		if (photos.length < 20 || photo_clusters.length == 0)
		{
            let firstGroupPhoto;
			for (let i = 0; i < photos.length; i++)
            {
                
                if (!firstGroupPhoto || !this._sameDay(this._getDate(firstGroupPhoto.date_taken), this._getDate(photos[i].date_taken)))
                {
                    firstGroupPhoto = photos[i];
                    photo_groups.push({'type':'label','text':this._getDate(firstGroupPhoto.date_taken, true)})
                }

                photo_groups.push(photos[i]);		
            }
				

			return photo_groups;
		}
	
		let allphotos = photo_clusters.flat();
		let showTime = true;
		for(let i=0; i< allphotos.length - 1; i++)
		{
			
			if (!this._sameDay(this._getDate(allphotos[i].date_taken), this._getDate(allphotos[i+1].date_taken)))
			{
				showTime = false;
				break;
			}
		
		}

		// i need to sort photos first 
		for(let i=0; i< photo_clusters.length; i++)
		{
			// check if more than one day in clusters
			let sameDay = true
			for (let j = 0; j < photo_clusters[i].length - 1; j++)
			{
				if (!this._sameDay(this._getDate(photo_clusters[i][j].date_taken), this._getDate(photo_clusters[i][j+1].date_taken)))
				{
					sameDay = false;
					break;
				}
			}

			if (!sameDay)
			{
				for (let j = 0; j < photo_clusters[i].length; j++)
				{
					if (j == 0 || !this._sameDay(this._getDate(photo_clusters[i][j].date_taken), this._getDate(photo_clusters[i][j-1].date_taken)))
						photo_groups.push({'type':'label','text': this._getDate(photo_clusters[i][j].date_taken, true) });

					photo_groups.push( photo_clusters[i][j]);
				}
			}
			else
			{
				let dateText;
				if (i == 0)
				{
					dateText = this._getDate(photo_clusters[i][0].date_taken, true);
				}
				else
				{

					if (photo_clusters.length > 1 && this._sameDay(this._getDate(photo_clusters[i-1][0].date_taken), this._getDate(photo_clusters[i][0].date_taken)))
					{
						if (showTime)
							dateText = this._getDate(photo_clusters[i][0].date_taken, true);
					}
					else
						dateText = this._getDate(photo_clusters[i][0].date_taken, true);
				}

				if (dateText)
					photo_groups.push({'type':'label','text':dateText})

				photo_groups = photo_groups.concat(photo_clusters[i]);
			}
		}
		
		return photo_groups;

	}

	dayGroups(photos)
	{
		let groups = [];

		photos = photos.sort( this._sortDateTaken );

		let currentIndex = -1;
		for (let i = 0; i < photos.length; i++)
		{
			if (i == 0 || !this._sameDay(this._getDate(photos.getItemAt(i-1).date_taken), this._getDate(photos.getItemAt(i).date_taken)))
				currentIndex++;
			
			if (!groups[currentIndex])
			groups[currentIndex] = {date : this._getDate(photos.getItemAt(i).date_taken), photos : []};

			groups[currentIndex].photos.push(photos.getItemAt(i));
		}

		return groups;
	}

	dbscan(photos)
	{
		if (photos.length == 0)
			return [];

		if (photos.length == 1)
			return [[photos.getItemAt(0)]];

		photos = photos.sort( this._sortDateTaken );

		//-- the table photos is given 
		let dates = {};
	
		// convert date_taken into minutes 
		for (let i=0; i < photos.length; i++)
		{
			// get the date alone 
			let d = this._getDate(photos[i].date_taken);
			
			let date = this._getDate(d.getFullYear().toString()+'-'+(d.getMonth()+1).toString()+'-'+d.getDate().toString());
			let time_in_minutes = d.getHours()*60 + d.getMinutes() + d.getSeconds()/60 ;

			if( ! (date in dates))
				dates[date] = {values : [time_in_minutes], date : d}
			else
				dates[date].values.push(time_in_minutes);
		}

		let data = []; 
		let keys = Object.keys(dates);
		let offest = 0;
		for(let i=0; i<keys.length; i++)
		{
			if (i > 0)
				//offest = Math.abs(dates[keys[i]].date - dates[keys[i - 1]].date) / (1000 * 60);
				offest = i * (24 * 60);

			let values = dates[keys[i]].values;

			for(let j=0; j < values.length; j++)
				data.push(values[j] + offest )
		}

		// compute distances 
		let distances = []
		let N = data.length;
		let photo_clusters = [];

		distances.push(Math.abs(data[0]-data[1]));

		for (let i=1; i < N-1; i++)
		{
			let a = Math.abs(data[i]-data[i+1])
			let b = Math.abs(data[i-1]-data[i])
			if(a > b)
				distances.push(b)
			else 
				distances.push(a)
		}

		distances.push(Math.abs(data[N-2]-data[N-1]));

		// also sort distances 
		distances.sort(function(a, b){ return a - b; });
		//distances.sort((a, b) => a - b);
	
		// find elbow point 
		//let x = [...Array(N).keys()];
		let x = [];
		for (let i = 0; i < N; i++)
			x.push(i);

		let knee = new KneeLocator(x,distances,"convex","increasing");
		let elbow_point = knee.find_Knee();

		// add a small value to include the points located on the circumference of the circle of radius epsilon 
		let epsilon = elbow_point[1] + Math.pow(10,-5)
		
		// call dbscan 
		let dbscan = new DBSCAN();

		// reshape data first 
		let reshaped_data = []
		for(let i=0; i < data.length; i++)
			reshaped_data.push([data[i]])
		
		let clusters = dbscan.run(reshaped_data, epsilon, 2);

		
		for (let i=0; i< clusters.length; i++)
		{
			let group = [];
			for (let j=0; j < clusters[i].length; j++)
				group.push(photos[clusters[i][j]])
			
			photo_clusters.push(group);
		}

		if (photo_clusters.length == 0)
			return photo_clusters;
		
		//handle cluster -1 (noise)
		for(let i=0; i< dbscan.noise.length; i++)
		{
			let item = dbscan.noise[i];
			let res = this._binary_search(clusters,item);

			if(res[0]==true)
			{
				fx.log.info("duplicate indices! something went wrong");
			}
			else 
			{
				let indice = res[1]; 
				if(indice==0)
					photo_clusters[0].unshift(photos[item]);
				else 
				if(indice == clusters.length)
					photo_clusters[clusters.length-1].push(photos[item]);
				else 
				{
					// the photo is located betwenn two clusters
					// we compute the distance to the orders and add the photo to the closest one 
					// we could have compared to the centroids but that will give K-means results and we don't want that :p 

					let n = clusters[indice-1].length;
					let a = clusters[indice-1][n-1]; // last item from the previous cluster
					let b = clusters[indice][0]; // first item from the next cluster 

					let distance1 = Math.abs(data[item] - data[a]);
					let distance2 = Math.abs(data[b] - data[item]); 
					if(distance1 > distance2)
						// add to the next cluster 
						photo_clusters[indice].unshift(photos[item]);
					else 
						photo_clusters[indice-1].push(photos[item]); 
				}
			}
		}

		return photo_clusters;
	
	}


	_binary_search(list_clusters, item)
	{
		let first = 0;
		let last = list_clusters.length -1; 
		let found = false;

		while( first <=last && !found)
		{
			let mid = Math.trunc((first + last)/2); 
			if (list_clusters[mid][0] == item) 
				found = true;
			else
			{
				if (item < list_clusters[mid][0])
					last = mid - 1;
				else
					first = mid + 1	;
			}
		}
				
		return [found, first];  
	}
	
	_sortDateTaken(a, b)
	{
		return a.date_taken_unix - b.date_taken_unix;
	}

	

	_filterPhotos(photo)
	{
		if ( !this.photosused && photo.number > 0)
			return false;

		return !photo.deleted && !((photo.labels == "share-uploader") && (photo.validated == 0));
	}


	_sameDay(d1, d2) 
	{
		return d1.getFullYear() === d2.getFullYear() &&
		  d1.getMonth() === d2.getMonth() &&
		  d1.getDate() === d2.getDate();
	}

	_getDate(date, pretty)
	{
		let d;
		if (date == "0000-00-00 00:00:00")
			d = new Date();
		else
			d = ( typeof date == "string" ? new Date(date.replace(/-/g, "/")) : date);

		return pretty ? d.pretty( fx.currentLocale() ) : d;
	}
});